import { IEhs, IEhsFile } from '@relab/alstom-ptw-shared';

import { ActionType, AppActionTypes } from '../types';

function ehsFormData(ehs: Partial<IEhs>, files?: { attachments?: IEhsFile[]; ehsClosureFile?: IEhsFile }): FormData {
  const formData = new FormData();
  if (files) {
    if (!!files.attachments) {
      for (const attachment of files.attachments) {
        if (!attachment._id) {
          formData.append('attachments', attachment as unknown as Blob);
        }
      }
    }
    if (files.ehsClosureFile) {
      formData.append('ehsClosureFile', files.ehsClosureFile as unknown as Blob);
    }
  }
  if (ehs.attachments) {
    ehs.attachments = ehs.attachments.filter((a) => !!a._id);
  }

  formData.append('ehs', JSON.stringify(ehs));
  return formData;
}

export function ehsCreateAction(
  ehs: Partial<IEhs>,
  files?: { attachments?: IEhsFile[]; ehsClosureFile?: IEhsFile }
): AppActionTypes {
  const data = ehsFormData(ehs, files);

  return {
    type: ActionType.EHS_CREATE,
    payload: {
      request: {
        url: '/ehs',
        method: 'post',
        data,
      },
    },
  };
}

export function ehsAction(ehsId: string): AppActionTypes {
  return {
    type: ActionType.EHS,
    payload: {
      request: {
        url: `/ehs/${ehsId}`,
        method: 'get',
      },
    },
  };
}

export function ehssAction(): AppActionTypes {
  return {
    type: ActionType.EHSS,
    payload: {
      request: {
        url: `/ehss`,
        method: 'get',
      },
    },
  };
}

export function ehsUpdateAction(
  ehs: Partial<IEhs>,
  files?: { attachments?: IEhsFile[]; ehsClosureFile?: IEhsFile }
): AppActionTypes {
  const data = ehsFormData(ehs, files);

  return {
    type: ActionType.EHS_UPDATE,
    payload: {
      request: {
        url: `/ehs/${ehs._id}`,
        method: 'post',
        data,
      },
    },
  };
}

export function ehsDeleteAction(ehsId: string): AppActionTypes {
  return {
    type: ActionType.EHS_DELETE,
    payload: {
      request: {
        url: `/ehs/${ehsId}`,
        method: 'delete',
      },
      ehs: {
        _id: ehsId,
      },
    },
  };
}
